import React, { useCallback } from 'react'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'

const RefNew = ({ block, position }) => {
    const renderBlockByPosition = useCallback(() => {
        const imageIllustrationArray = block.childrens.filter(
            (child) => child.block === 'ImageIllustration'
        )
        switch (position) {
            case 'horizontal':
                const otherElementsArray = block.childrens.filter(
                    (child) => child.block !== 'ImageIllustration'
                )
                const order = ['SurTitre', 'Titre', 'Date', 'Introduction']
                otherElementsArray.sort((a, b) => order.indexOf(a.block) - order.indexOf(b.block))

                return (
                    <div class="baseocom-actualite-content">
                        <a
                            href={block?.attributes.post_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            class="baseocom-link-actualite"
                        ></a>

                        <Parser content_block={imageIllustrationArray} position={position} />

                        <div class="baseocom-text-content">
                            <Parser content_block={otherElementsArray} position={position} />
                        </div>
                    </div>
                )
            case 'vertical':
                const verticalElementsArray = block.childrens.filter(
                    (child) => child.block === 'SurTitre' || child.block === 'Titre'
                )

                return (
                    <div class="baseocom-actualite-content">
                        <a
                            href={block?.attributes.post_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            class="baseocom-link-actualite"
                        ></a>

                        <Parser content_block={imageIllustrationArray} position={position} />

                        <div class="baseocom-text-content">
                            <Parser content_block={verticalElementsArray} position={position} />
                            <span className="baseocom-icon-arrow-right">{icon('arrow-right')}</span>
                        </div>
                    </div>
                )
        }
    }, [block, position])

    return (
        <>
            {block?.content && <p>{block?.content}</p>}
            {renderBlockByPosition()}
        </>
    )
}

export default RefNew
